import React, { useEffect, useRef, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../common/axios";
import useGet from "../../hooks/useGet";
import { getErrors, hasData, toastDefault } from "../../utils/handler.utils";
import Loader from "../Loader/Loader";
function EditPackage(props) {
  const history = useHistory();
  const packageId = props.match.params.id;

  const [loading, setLoading] = useState(null);
  const [autoDelivery, setAutoDelivery] = useState(false);
  const [directDelivery, setDirectDelivery] = useState(false);
  const [isMultiple, setIsMultiple] = useState(false);
  const [childPackages, setChildPackages] = useState([]);
  const [selectedChild, setSelectedChild] = useState("");
  const [packageProductId, setPackageProductId] = useState("");
  const [selectedProductId, setSelectedProductId] = useState("");
  const [data, loadingData] = useGet(`admin/topup-package/${packageId}`);
  const [products, loadingProducts] = useGet(`admin/topup-products`);

  const product_id = useRef(null);
  const searchProductId = useRef(null);
  const name = useRef(null);
  const sell_price = useRef(null);
  const buy_price = useRef(null);
  const tagRef = useRef(null);
  const voucherPrefixRef = useRef(null);
  const in_stock = useRef(null);
  const mapPackage = useRef(null);
  const autoDeliveryRef = useRef(null);
  const directDeliveryRef = useRef(null);
  const directDeliveryServerRef = useRef(null);
  const directDeliveryCodeRef = useRef(null);
  const uniquePurchaseRef = useRef(null);

  const autoDeliveryChange = (e) => {
    setAutoDelivery(autoDeliveryRef.current.checked);
  };

  const directDeliveryChange = (e) => {
    setDirectDelivery(directDeliveryRef.current.checked);
  };

  const [packages, loadingPackages] = useGet(
    packageProductId ? `admin/topup-packages/${packageProductId}` : "",
    "",
    packageProductId
  );

  useEffect(() => {
    if (data) {
      setAutoDelivery(data.auto_delivery === 1);
      setDirectDelivery(data.direct_delivery === 1);
      setIsMultiple(
        data.is_multiple === 1 ||
          data.isMultiple === 1 ||
          data?.is_multiple === true
      );
      setPackageProductId(data.product_id);
      setSelectedProductId(data.product_id);
      const childList = data.childs || [];
      if (Array.isArray(childList)) {
        setChildPackages(
          childList
            .map((child) => {
              if (typeof child === "number") return child;
              if (typeof child === "string") return Number(child);
              return (
                child?.child_package_id ??
                child?.id ??
                child?.package_id ??
                null
              );
            })
            .filter((childId) => childId)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingData]);

  const selectedProduct = products?.find(
    (product) => String(product.id) === String(selectedProductId)
  );
  const isVoucherProduct = selectedProduct?.topup_type === "voucher";

  const editPackageHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    const autoDeliveryValue = autoDeliveryRef.current.checked ? 1 : 0;
    const isMultipleValue = autoDeliveryValue === 1 && isMultiple ? 1 : 0;
    const payload = {
      product_id: product_id.current.value,
      name: name.current.value,
      price: sell_price.current.value,
      buy_price: buy_price.current.value,
      tag: tagRef.current.value,
      direct_delivery_server: directDeliveryServerRef.current?.value ?? null,
      direct_delivery_code: directDeliveryCodeRef.current?.value ?? null,
      map_voucher_package: mapPackage?.current?.value ?? null,
      auto_delivery: autoDeliveryValue,
      direct_delivery: directDeliveryRef.current.checked ? 1 : 0,
      in_stock: in_stock.current.checked ? 1 : 0,
      unique_purchase: uniquePurchaseRef.current.checked ? 1 : 0,
      isMultiple: isMultipleValue,
      childs: isMultipleValue ? childPackages : [],
    };

    if (isVoucherProduct) {
      payload.voucher_prefix = voucherPrefixRef.current?.value ?? "";
    }

    if (autoDeliveryValue === 1 && isMultipleValue === 0) {
      payload.childs = [];
    }

    axiosInstance
      .post(`/admin/topup-package/update/${packageId}`, payload)
      .then((res) => {
        toast.success("Topup package updated successfully", toastDefault);

        setTimeout(() => {
          history.push("/topup-packages");
        }, 1500);
      })
      .catch((err) => {
        toast.error(getErrors(err, false, true), toastDefault);
        setLoading(false);
      });
  };

  return (
    <section className="relative container_admin">
      <div className="bg-white overflow-hidden rounded">
        <div className="px-6 py-3 border-b border-gray-200">
          <h3 className="text-lg font-bold text-black">
            Edit topup package -- {data?.name}
          </h3>
        </div>
        <div className="py-10 px-4">
          <div className="w-full md:w-[70%] min-h-[250px] mx-auto py-6 relative border border-gray-200 px-4">
            {loadingData || loading || loadingProducts || loadingPackages ? (
              <Loader absolute />
            ) : (
              ""
            )}
            {hasData(data) && hasData(products) && (
              <form onSubmit={editPackageHandler}>
                <div>
                  <div className="form_grid">
                    <div>
                      <label htmlFor="name">Product</label>
                      <select
                        defaultValue={data?.product_id}
                        ref={product_id}
                        className="form_input"
                        onChange={(e) => setSelectedProductId(e.target.value)}
                      >
                        {products?.map((product) => (
                          <option value={product.id}>{product.name}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label htmlFor="name">Name</label>
                      <input
                        ref={name}
                        id="name"
                        defaultValue={data?.name}
                        className="form_input"
                        type="text"
                        placeholder="Name"
                        required
                      />
                    </div>
                  </div>
                  <div className="form_grid">
                    <div>
                      <label htmlFor="sell_price">Sell price</label>
                      <input
                        ref={sell_price}
                        step="any"
                        id="sell_price"
                        defaultValue={data?.price}
                        className="form_input"
                        type="number"
                        placeholder="Sell price"
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="buy_price">Buy price</label>
                      <input
                        ref={buy_price}
                        id="buy_price"
                        defaultValue={data?.buy_price}
                        className="form_input"
                        type="number"
                        placeholder="Buy price"
                        required
                      />
                    </div>
                  </div>

                  <div className="form_grid">
                    <div>
                      <label htmlFor="tag">Tag name</label>
                      <input
                        ref={tagRef}
                        defaultValue={data?.tag}
                        id="tag"
                        className="form_input"
                        type="text"
                        placeholder="Tag"
                      />
                    </div>
                  </div>

                  {isVoucherProduct && (
                    <div className="form_grid">
                      <div>
                        <label htmlFor="voucher_prefix">Voucher prefix</label>
                        <input
                          ref={voucherPrefixRef}
                          defaultValue={data?.voucher_prefix}
                          id="voucher_prefix"
                          className="form_input"
                          type="text"
                          placeholder="Voucher prefix"
                        />
                      </div>
                    </div>
                  )}

                  {autoDelivery && (
                    <>
                      <h1 className="text-xl">Auto delivery Section</h1>
                      Current Package ID: {data.map_voucher_package_id}
                      <div className="space-y-3">
                        <div className="form_grid">
                          <div>
                            <label htmlFor="name">Product</label>
                            <select
                              ref={searchProductId}
                              value={packageProductId}
                              onChange={(e) =>
                                setPackageProductId(e.target.value)
                              }
                              className="form_input"
                            >
                              <option value="">Select A Product</option>
                              {products?.map((product) => (
                                <option value={product.id}>
                                  {product.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="flex items-end">
                            <label className="inline-flex items-center">
                              <input
                                id="is_multiple"
                                value="1"
                                onChange={() => setIsMultiple(!isMultiple)}
                                className="form-checkbox"
                                type="checkbox"
                                checked={isMultiple}
                              />
                              <span className="ml-2">Is multiple</span>
                            </label>
                          </div>
                        </div>

                        {!isMultiple && (
                          <div className="form_grid">
                            <div>
                              <label htmlFor="name">Package Select</label>
                              <select
                                ref={mapPackage}
                                className="form_input"
                                defaultValue={data.map_voucher_package_id ?? ""}
                              >
                                {loadingPackages && (
                                  <option value="">Loading...</option>
                                )}
                                {!loadingPackages &&
                                  packages?.map((pack) => (
                                    <option value={pack.id}>{pack.name}</option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        )}

                        {isMultiple && (
                          <div className="space-y-2">
                            <div className="form_grid">
                              <div>
                                <label htmlFor="name">Package Select</label>
                                <div className="flex space-x-2">
                                  <select
                                    className="form_input"
                                    value={selectedChild}
                                    onChange={(e) =>
                                      setSelectedChild(e.target.value)
                                    }
                                  >
                                    <option value="">Select package</option>
                                    {loadingPackages && (
                                      <option value="">Loading...</option>
                                    )}
                                    {!loadingPackages &&
                                      packages?.map((pack) => (
                                        <option value={pack.id}>
                                          {pack.name}
                                        </option>
                                      ))}
                                  </select>
                                  <button
                                    type="button"
                                    className="cstm_btn_small"
                                    onClick={() => {
                                      if (!selectedChild) return;
                                      setChildPackages((prev) => [
                                        ...prev,
                                        Number(selectedChild),
                                      ]);
                                      setSelectedChild("");
                                    }}
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div>
                              <label className="block mb-1">
                                Selected packages
                              </label>
                              {childPackages?.length ? (
                                <ul className="space-y-1">
                                  {childPackages.map((childId, index) => {
                                    const pkg =
                                      packages?.find(
                                        (pack) => Number(pack.id) === childId
                                      ) || null;
                                    return (
                                      <li
                                        key={`${childId}-${index}`}
                                        className="flex items-center justify-between bg-gray-100 px-2 py-1 rounded"
                                      >
                                        <span className="text-sm">
                                          {pkg?.name || "Package"} (ID:{" "}
                                          {childId})
                                        </span>
                                        <button
                                          type="button"
                                          className="text-red-600 text-sm"
                                          onClick={() =>
                                            setChildPackages((prev) =>
                                              prev.filter(
                                                (_, idx) => idx !== index
                                              )
                                            )
                                          }
                                        >
                                          Remove
                                        </button>
                                      </li>
                                    );
                                  })}
                                </ul>
                              ) : (
                                <p className="text-sm text-gray-500">
                                  No package selected yet.
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {directDelivery && (
                    <div className="form_grid">
                      <div>
                        <label htmlFor="direct_delivery_server">
                          Direct Delivery Server
                        </label>
                        <input
                          ref={directDeliveryServerRef}
                          id="direct_delivery_server"
                          defaultValue={data?.direct_delivery_server}
                          className="form_input"
                          type="text"
                          placeholder="Direct Delivery Server"
                          required
                        />
                      </div>

                      <div>
                        <label htmlFor="direct_delivery_code">
                          Direct Delivery Code
                        </label>
                        <input
                          ref={directDeliveryCodeRef}
                          id="direct_delivery_code"
                          defaultValue={data?.direct_delivery_code}
                          className="form_input"
                          type="text"
                          placeholder="Direct Delivery Code"
                          required
                        />
                      </div>
                    </div>
                  )}

                  <div>
                    <label class="inline-flex items-center">
                      <input
                        ref={uniquePurchaseRef}
                        id="direct_delivery"
                        value="1"
                        className="form-checkbox"
                        type="checkbox"
                        defaultChecked={
                          data?.unique_purchase == 1 ? true : false
                        }
                      />
                      <span class="ml-2">Unique Purchase</span>
                    </label>
                  </div>

                  <div className="form_grid">
                    <div>
                      <label class="inline-flex items-center">
                        <input
                          ref={in_stock}
                          id="in_stock"
                          value="1"
                          className="form-checkbox"
                          type="checkbox"
                          defaultChecked={data?.in_stock == 1 ? true : false}
                        />
                        <span class="ml-2">In Stock</span>
                      </label>
                    </div>

                    <div>
                      <label class="inline-flex items-center">
                        <input
                          ref={autoDeliveryRef}
                          id="auto_delivery"
                          value="1"
                          onChange={autoDeliveryChange}
                          className="form-checkbox"
                          type="checkbox"
                          defaultChecked={
                            data?.auto_delivery == 1 ? true : false
                          }
                        />
                        <span class="ml-2">Auto delivery</span>
                      </label>
                    </div>

                    <div>
                      <label class="inline-flex items-center">
                        <input
                          ref={directDeliveryRef}
                          id="direct_delivery"
                          value="1"
                          onChange={directDeliveryChange}
                          className="form-checkbox"
                          type="checkbox"
                          defaultChecked={
                            data?.direct_delivery == 1 ? true : false
                          }
                        />
                        <span class="ml-2">Direct delivery</span>
                      </label>
                    </div>
                  </div>

                  <div>
                    <button type="submit" className="cstm_btn w-full block">
                      Edit package
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default withRouter(EditPackage);
